<template>
  <div class="page-wrapper">
  <div class="module-card">
    <div class="module-header mb-2">
      <h2>Organizations</h2>
      <button class="add-module-btn" aria-label="Add organization" title="Add organization" @click="openAddOrg">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 1V13M1 7H13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6 mb-3">
          <div class="filter-bar">
      <div class="filter-field">
        <label>Organization Name</label>
        <input
          type="text"
          v-model="filters.organizationName"
          placeholder="Search by organization name"
          @keyup.enter="searchOrganizations"
        />
      </div>
      <div class="filter-field">
        <label>Status</label>
        <select v-model="filters.isActive">
          <option value="">All</option>
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>
      </div>
      <button type="button" class="search-btn" @click="searchOrganizations">
        <i class="fa-solid fa-magnifying-glass"></i> Search
      </button>
    </div>
      </div>
    </div>
    <div class="table-scroll">
    <table class="module-table">
      <thead>
        <tr>
          <th style="width: 160px;">Organization Name</th>
          <th style="width: 170px;">URL</th>
          <th style="width: 140px;">Root User Name</th>
          <th style="width: 170px;">Root User Email</th>
          <th style="width: 200px;">Connection String</th>
          <th style="width: 180px;">Welcome Text</th>
          <th style="width: 150px;">Logo URL</th>
          <th class="text-center" style="width: 90px;">Status</th>
          <th class="text-center sticky-col sticky-edit" style="width: 70px;">Edit</th>
          <th class="text-center sticky-col sticky-delete" style="width: 70px;">Delete</th>
          <th class="text-center sticky-col sticky-actions" style="width: 75px;">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="o in orgs" :key="o.id">
          <td>{{ o.name }}</td>
          <td>
            <a v-if="o.url" class="url-link" :href="o.url" target="_blank" rel="noopener" :title="o.url">{{ o.url }}</a>
          </td>
          <td>{{ o.rootName }}</td>
          <td>{{ o.rootEmail }}</td>

          <td class="clamp-cell">
            <span class="clamp-text" :class="{ expanded: isCellExpanded(o.id, 'connectionString') }">{{ o.connectionString }}</span>
            <a v-if="o.connectionString && o.connectionString.length > 40" class="more-less-link" @click="toggleCell(o.id, 'connectionString')">
              {{ isCellExpanded(o.id, 'connectionString') ? 'less' : 'more' }}
            </a>
          </td>

          <td class="clamp-cell">
            <span class="clamp-text" :class="{ expanded: isCellExpanded(o.id, 'welcomeText') }">{{ o.welcomeText }}</span>
            <a v-if="o.welcomeText && o.welcomeText.length > 40" class="more-less-link" @click="toggleCell(o.id, 'welcomeText')">
              {{ isCellExpanded(o.id, 'welcomeText') ? 'less' : 'more' }}
            </a>
          </td>

          <td>
            <a v-if="o.logoUrl" class="url-link" :href="o.logoUrl" target="_blank" rel="noopener" :title="o.logoUrl">{{ o.logoUrl }}</a>
          </td>

          <td class="center"><span class="badge" :class="{ inactive: !o.active }">{{ o.active ? 'Active' : 'Inactive' }}</span></td>

          <td class="center sticky-col sticky-edit"><i class="fa-solid fa-pen-to-square" @click="openEditOrg(o)"></i></td>
          <td class="center sticky-col sticky-delete"><i class="fa-solid fa-trash" @click="deleteOrganization(o)"></i></td>

          <td class="center sticky-col sticky-actions actions-cell">
            <i class="fa-solid fa-ellipsis-vertical text-secondary" @click="toggleActionMenu(o.id, $event)"></i>
          </td>
        </tr>
      </tbody>
    </table>
    </div>

    <!-- Pagination -->
    <div class="pagination-bar" v-if="totalCount > 0">
      <span class="pagination-info">
        Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }}
      </span>
      <div class="pagination-controls">
        <button
          type="button"
          class="page-btn"
          :disabled="currentPage === 1"
          @click="prevPage"
        >
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <span class="page-indicator">Page {{ currentPage }} of {{ totalPages }}</span>
        <button
          type="button"
          class="page-btn"
          :disabled="currentPage === totalPages"
          @click="nextPage"
        >
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Create / Edit organization modal -->
    <OrganizationModal
      ref="orgModal"
      @organization-created="onOrgSaved"
      @organization-updated="onOrgSaved"
    />

    <teleport to="body">
      <div v-if="openActionMenuId !== null" class="menu-backdrop" @click="closeActionMenu"></div>
      <div
        v-if="openActionMenuId !== null"
        class="action-menu"
        :style="actionMenuStyle"
      >
        <div class="action-menu-item" @click="toggleOrgStatus(activeOrg)">
          {{ activeOrg && activeOrg.active ? 'Deactivate' : 'Activate' }}
        </div>
      </div>
    </teleport>
  </div>
  </div>
</template>

<script>
import organizationListLogic from './organization.js';
export default organizationListLogic;
</script>

<style>
.action-menu {
  position: fixed;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.12);
  z-index: 1000;
  min-width: 110px;
  overflow: hidden;
}
.action-menu .action-menu-item {
  padding: 8px 14px;
  font-size: 12px;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  text-align: left;
}
.action-menu .action-menu-item:hover { background: #f3f4f6; color: #0f6e56; }
.menu-backdrop {
  position: fixed;
  inset: 0;
  z-index: 999;
}
.fa-pen-to-square{
  color: rgb(1, 108, 147);
}
.fa-trash {
  width: 26px;
  height: 26px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #fff;
  text-shadow:
    -1px -1px 0 #580909,
     1px -1px 0 #580909,
    -1px  1px 0 #580909,
     1px  1px 0 #580909;
}
.filter-bar {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  padding: 4px 12px 4px;
  flex-wrap: wrap;
}
.filter-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.filter-field label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
}
.filter-field input,
.filter-field select {
  height: 30px;
  padding: 0 10px;
  font-size: 11px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #1f2937;
  min-width: 200px;
  background: #fff;
}
.filter-field input:focus,
.filter-field select:focus {
  outline: none;
  border-color: #0f6e56;
}
.search-btn {
  height: 30px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px;
  background: #0f6e56;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.search-btn:hover {
  background: #0c5a46;
}
</style>
